import { render, staticRenderFns } from "./invigilate.vue?vue&type=template&id=f83985d0&scoped=true"
import script from "./invigilate.vue?vue&type=script&lang=js"
export * from "./invigilate.vue?vue&type=script&lang=js"
import style0 from "./invigilate.vue?vue&type=style&index=0&id=f83985d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83985d0",
  null
  
)

export default component.exports